module.exports = __webpack_public_path__ + "assets/img/service1.ca78f9d4.png";